import type { settings as en } from '@/i18n/locales/en/settings';
import type { Translation } from '@/i18n/types';

export const settings: Translation<typeof en> = {
  title: 'Instellingen',
  lead: 'Je bedrijfsprofiel, huisstijl en privacy-instellingen.',
  noCompany: 'Geen actief bedrijf geselecteerd.',
  adminOnly: 'Alleen een platformbeheerder kan dit wijzigen — je ziet wel de huidige waarden.',
  save: 'Opslaan',
  nav: {
    label: 'Instellingenmenu',
    profile: 'Profiel',
    branding: 'Huisstijl',
    privacy: 'Privacy',
    modules: 'Modules',
  },
  profile: {
    title: 'Profiel',
    name: 'Organisatienaam',
    industry: 'Branche',
    industryHint: 'Vrije tekst, bv. "Logistiek" of "Zorg".',
    employeeCount: 'Aantal medewerkers',
    plan: 'Abonnement',
    planPlaceholder: 'Zie Abonnement',
  },
  branding: {
    title: 'Huisstijl',
    lead: 'Je logo en accentkleur, zoals ze in een live voorbeeld verschijnen.',
    logo: 'Logo uploaden',
    logoHint: 'Wordt direct geüpload; of vul hieronder een bestaande URL in.',
    logoUrl: 'Logo-URL',
    upload: {
      uploading: 'Bezig met uploaden…',
      tooLarge: 'Bestand is te groot (max. 10MB).',
      invalidType: 'Bestandstype niet toegestaan.',
    },
    accentColor: 'Accentkleur',
    preview: 'Live voorbeeld',
    colors: {
      mint: 'Mint',
      pine: 'Dennengroen',
      ink: 'Zwart',
      amber: 'Amber',
      coral: 'Koraal',
      sky: 'Hemelsblauw',
    },
  },
  privacy: {
    title: 'Privacy',
    lead: 'De minimale groepsgrootte voor geaggregeerde statistieken, en wat je bedrijf deelt.',
    minGroupSize: 'Minimale groepsgrootte (k-anonimiteit)',
    minGroupSizeHint:
      'Onder deze grens is een groep te klein om geaggregeerde statistieken voor te tonen.',
    minGroupSizeValue: '{{count}} personen',
    effective: 'Nu van kracht: {{count}} personen',
    aggregatedData: 'Geaggregeerde data',
    aggregatedDataHint:
      'Toon geaggregeerde statistieken voor groepen die de minimale grootte halen.',
    explicitConsent: 'Expliciete toestemming vereist',
    explicitConsentHint:
      'Vereis een individueel toestemmingsantwoord in plaats van collectieve toestemming.',
    dataExport: 'Data-export',
    dataExportHint: 'Sta het exporteren van statistiekgegevens toe.',
    auditLogHint: 'Beheerhandelingen worden altijd vastgelegd in een audittrail.',
  },
  modules: {
    title: 'Modules',
    lead: 'Schakel de modules voor je bedrijf in of uit.',
    vitality: 'Vitaliteit',
    vitalityHint: 'Slaap, stress, hartslag en activiteitenregistratie.',
    participation: 'Participatie',
    participationHint: 'Engagement funnel en participatiemetrieken.',
    pilots: 'Pilots',
    pilotsHint: "Voer en volg pilotprogramma's uit.",
    challenges: 'Challenges',
    challengesHint: 'Maak en beheer wellnesschallenges.',
    communication: 'Communicatie',
    communicationHint: 'Stuur meldingen en berichten naar medewerkers.',
    documents: 'Documenten',
    documentsHint: 'Publiceer en beheer bedrijfsdocumenten.',
    reports: 'Rapportages',
    reportsHint: 'Genereer en exporteer analytische rapporten.',
    ai_coach: 'AI Coach',
    ai_coachHint: 'AI-aangestuurde persoonlijke begeleiding.',
  },
};
